/**
 * This file originated from:
 * File: app/assets/javascripts/src-zugz/bonz/modules/validationTip.js
 * In commit: de125d9c0dbfa23a5f12f049c70f4e9e185a6932
 * For ticket: GRINS-1507
 */

const module = { name: 'bonz/modules/validationTip', exports: {} }; const exports = module.exports;

const Styles = {
    HIDE: 'hide'
}
const Attribs = {
    EXPANDED: 'aria-expanded',
    HIDDEN: 'aria-hidden',
}
function toggle(id, isVisible, msg) {
    const container = document.querySelector(`#validation-tip-${id}`);
    const content = document.querySelector(`#validation-tip-${id}-content`);
    if (!container || !content) {
        return;
    }
    content.innerHTML = msg || '';
    content.setAttribute(Attribs.HIDDEN, !isVisible);
    container.setAttribute(Attribs.EXPANDED, isVisible);
    container.classList.toggle(Styles.HIDE, !isVisible);
}
export default {
    show(id, msg) {
        if (!msg) {
            return;
        }
        toggle(id, true, msg);
    },
    hide(id) {
        toggle(id, false);
    }
};